import { z } from "zod";

import unauthenticatedHttp from "@/services/unauthenticatedHttp";

import { popularProduct } from "../instanceService";
import { featuredCardData } from "../marketingManagementService/marquees";

export async function subscriptions() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/subscriptions`
  );

  return data;
}

const offersData = z.object({
  active: z.boolean(),
  promotionStartTime: z.string(),
  productIds: z.array(z.string()),
  description: z.string(),
});

export async function unAuthFeaturedOffers() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/featured-offers`
  );
  if (!data) {
    return;
  }
  return offersData.parse(data);
}

const featureOptions = z
  .object({
    data: z.array(featuredCardData),
  })
  .strict();

export async function unauthMarketingInfo() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/marketing-info`
  );
  if (!data) {
    return;
  }
  return featureOptions.parse(data);
}

const popularNewResponse = z.object({
  popular_catalogs: z.array(popularProduct).nullish(),
  new_catalogs: z.array(popularProduct).nullish(),
});

export async function unauthPopularNew() {
  const { data } = await unauthenticatedHttp().get(
    `${globalThis.env.API_UNAUTH}/store/popular-new-catalogs`
  );
  if (!data) {
    return;
  }
  return popularNewResponse.parse(data);
}
